import { Component } from '@angular/core';
import { isString } from 'lodash';

@Component({
  selector: 'eva-root',
  template: '<eva-navigation></eva-navigation>',
  styles: []
})
export class AppComponent { 
  constructor() { }
}
